// import React from 'react'
// import Loader from './Loader'

// function Service() {
//   return (
//     <div>
//       <Loader/>
//     </div>
//   )
// }

// export default Service

import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/style.css";

const services = [
  {
    title: "Building Construction",
    image: "/img/main.jpeg",
    description:
      "Saara Constructions delivers commercial projects such as malls, office buildings, retail complexes, and showrooms with precision engineering. Our commercial constructions ensure maximum space utilization, safety, and a premium customer experience.",
  },
  {
    title: "House Renovation",
    image: "img/residence.jpeg",
    description:
      "We specialize in building high-quality residential homes that are structurally strong, aesthetically appealing, and built to last. From independent houses to premium apartments, we ensure perfect planning, modern design, and timely delivery.",
  },
  {
    title: "Architecture Design",
    image: "img/service-3.jpg",
    description:
      "We design and build industrial structures including warehouses, factories, workshops, and storage units. Our team focuses on durability, safety, and compliance with all industrial standards for long-term operational efficiency.",
  },
  {
    title: "Interior Design",
    image: "img/service-4.jpg",
    description:
      "Our interior design team creates functional, modern, and stylish interiors for homes, offices, and commercial spaces. We handle design, material selection, and complete execution to deliver beautiful results.",
  },
  {
    title: "Fixing & Support",
    image: "img/service-5.jpg",
    description:
      "Our expert structural engineers provide safe, detailed, and optimized designs. We ensure that every building we work on meets the highest engineering standards for strength, safety, and performance.",
  },
  {
    title: "Road & Infrastructure Development",
    image: "img/roadservice.jpg",
    description:
      "Saara Construction undertakes road construction, drainage systems, pavements, and other civil infrastructure works with high durability and government-standard quality.",
  },
];

const Service = () => {
  return (
    <div className="service">
      <div className="container">
        <div className="section-header text-center">
          <p>Our Services</p>
          <h2>We Provide Services</h2>
        </div>
        <div className="row">
          {services.map((service, index) => (
            <div key={index} className={`col-lg-4 col-md-6 wow fadeInUp`} data-wow-delay={`${0.1 * (index + 1)}s`}>
              <div className="service-item">
                <div className="service-img">
                  <img src={service.image} alt={service.title} />
                  <div className="service-overlay">
                    <p>{service.description}</p>
                  </div>
                </div>
                <div className="service-text">
                  <h3>{service.title}</h3>
                  <a className="btn" href={service.image} data-lightbox="service">+</a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Service;
